import {
    addOrUpdateRoleURL,
    getPrivilegesURL,
    getRoleBasedPrivilegesURL,
    updatePrivilagesForTheRoleURL,
} from "../../apiEndPoints"
import { axiosGet, axiosPost, axiosPut } from "../../utilities/axiosRequest"
import { logTransaction } from "../appActions"
import { updatePriviliges } from "./roleSlice"

export function fetchPrivileges(success, failure) {
    return function (dispatch, getState) {
        // dispatch(updateLoading(true));
        let url = getPrivilegesURL
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData || [])
                    dispatch(logTransaction("Fetch Privileges", response))
                    dispatch(updatePriviliges(response.data.responseData))
                } else {
                    failure(response.data.statusMSG)
                    dispatch(logTransaction("Fetch Privileges error", response))
                    dispatch(updatePriviliges([]))
                }
                // dispatch(updateLoading(false));
            })
            .catch(err => {
                failure("Failed to fetch priviliges")
                dispatch(logTransaction("Fetch Privileges failure", err))
                dispatch(updatePriviliges([]))
                // dispatch(updateLoading(false));
            })
    }
}

export function insertOrUpdateRole(data, success, error) {
    return function (dispatch, getState) {
        let user = getState().login.user
        // let orgId = user?.organizationlistforuser?.[0]?.organizationId
        // let clinicId = user?.clinicListForUser?.[0]?.clinicId
        let url = addOrUpdateRoleURL
        // let userId = user?.profileForUser[0]?.userId
        let inputData = data
        // if (orgId !== undefined && orgId !== null) {
        //     inputData.organizationId = orgId
        // }
        // if (clinicId !== undefined && clinicId !== null) {
        //     inputData.clinicId = clinicId
        // }
        // inputData.createdBy = userId
        // inputData.lastUpdatedBy = userId

        axiosPost(url, inputData)
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(logTransaction("Role Updated", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Role Updation error", response))
                    error(response.data.statusMSG || "Failed to add user")
                }
            })
            .catch(err => {
                dispatch(logTransaction("Role Updation failure", err))
                error(err.message || "Faile to add user")
            })
    }
}

export function getRoleBasedPrivileges(roleId, success, error) {
    return function (dispatch, getState) {
        let url = getRoleBasedPrivilegesURL + `?roleId=${roleId}`
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(
                        logTransaction(
                            "Role Based Privileges fetch success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "Role Based Privileges fetch failure",
                            response
                        )
                    )
                    error(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("Role Based Privileges fetch failure", err)
                )
                error(err.message)
            })
    }
}

export function updatePrivilagesForTheRole(data, success, error) {
    return function (dispatch, getState) {
        console.log(data, "sdklfjsdfj")
        let url = updatePrivilagesForTheRoleURL
        axiosPut(url, JSON.stringify(data))
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(
                        logTransaction(
                            "Role Based Privileges fetch success",
                            response
                        )
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "Role Based Privileges fetch failure",
                            response
                        )
                    )
                    error(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("Role Based Privileges fetch failure", err)
                )
                error(err.message)
            })
    }
}
